import { Check, DescriptionOutlined } from '@mui/icons-material'
import { catalogColumnType, catalogFilterColumnType, catalogItemType, catalogTabType } from '../catalogTypes'

export interface naspoItemType extends catalogItemType {
  productType: string
  contractProdCategory: string
  unspsc: string
  sku: string
  description: string
  contractUnitListPrice: number
  contractMinDiscount: number
  contractUnitNetPrice: number
}

const ALL_NASPO_COLUMNS: catalogColumnType[] = [
  { key: 'productType', label: 'Product Type', width: '150px' },
  { key: 'contractProdCategory', label: 'Contract Product Category', width: '150px' },
  { key: 'unspsc', label: 'UNSPSC', width: '100px' },
  { key: 'sku', label: 'SKU', width: '100px' },
  { key: 'description', label: 'Description', width: '200px' },
  {
    key: 'contractUnitListPrice',
    label: 'Contract Unit List Price (MSRP)',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
  {
    key: 'contractMinDiscount',
    label: 'Contract Minimum Discount (%)',
    width: '100px',
    inputType: 'percentage',
    align: 'right',
  },
  {
    key: 'contractUnitNetPrice',
    label: 'Contract Unit Net Price',
    width: '100px',
    inputType: 'currency',
    align: 'right',
  },
]

export const naspoColumnMapping = new Map<string, catalogColumnType[]>([
  ['ar3227', ALL_NASPO_COLUMNS],
  [
    'ar3227:Modifications',
    [
      { key: 'modType', label: 'Product Type', width: '75px' },
      {
        key: 'modDate',
        label: 'MOD Date',
        width: '75px',
        inputType: 'date',
      },
      { key: 'status', label: 'Status', width: '50px' },
      { key: 'uploadedFile', label: 'Uploaded File', width: '150px' },
    ],
  ],
  [
    'ar3227:MOD Report | Price Increase',
    [
      {
        key: 'modDate',
        label: 'MOD Date',
        width: '75px',
        inputType: 'date',
      },
      {
        key: 'oldPrice',
        label: 'Old Price',
        width: '75px',
        inputType: 'currency',
      },
      {
        key: 'updatedPrice',
        label: 'Updated Price',
        width: '75px',
        inputType: 'currency',
      },
      ...ALL_NASPO_COLUMNS,
    ],
  ],
  [
    'ar3227:MOD Report | Price Decrease',
    [
      {
        key: 'modDate',
        label: 'MOD Date',
        width: '75px',
        inputType: 'date',
      },
      {
        key: 'oldPrice',
        label: 'Old Price',
        width: '75px',
        inputType: 'currency',
      },
      {
        key: 'updatedPrice',
        label: 'Updated Price',
        width: '75px',
        inputType: 'currency',
      },
      ...ALL_NASPO_COLUMNS,
    ],
  ],
  [
    'ar3227:MOD Report | Item Additions',
    [
      {
        key: 'modDate',
        label: 'MOD Date',
        width: '75px',
        inputType: 'date',
      },
      ...ALL_NASPO_COLUMNS,
    ],
  ],
  [
    'ar3227:MOD Report | Item Deletions',
    [
      {
        key: 'modDate',
        label: 'MOD Date',
        width: '75px',
        inputType: 'date',
      },
      ...ALL_NASPO_COLUMNS,
    ],
  ],
])

export const naspoTabGroups = new Map<string, catalogTabType[]>([
  [
    'ar3227',
    [
      { label: 'AR3227', icon: <DescriptionOutlined />, source: 'ar3227' },
      { label: 'Modifications', icon: <Check />, source: 'ar3227/modifications', isModification: true },
      { label: 'MOD Report | Price Increase', source: 'ar3227' },
      { label: 'MOD Report | Price Decrease', source: 'ar3227' },
      { label: 'MOD Report | Item Additions', source: 'ar3227' },
      { label: 'MOD Report | Item Deletions', source: 'ar3227' },
    ],
  ],
])

export const naspoColumnFilters = new Map<string, catalogFilterColumnType[]>([
  [
    'ar3227',
    [
      { key: 'productType', label: 'Product Type' },
      { key: 'contractProdCategory', label: 'Contract Product Category' },
      { key: 'description', label: 'Description' },
    ],
  ],
])
